import { useRef, useEffect } from "react"

// Hook for closing the Popup component
// Listens for 'Esc' keydown event and when user presses outside of the component
// options: { closeOnEsc: boolean, closeOnOutsideClick: boolean }
export const useClosePopup = (handler, options = { closeOnEsc: true, closeOnOutsideClick: true }) => {
  let domNode = useRef(null)

  useEffect(() => {
    let handleKeyPress = (event) => {
      if (options.closeOnEsc && event.key === "Escape") {
        handler()
      }
    }

    let handleClick = (event) => {
      if (options.closeOnOutsideClick && domNode.current && !domNode.current.contains(event.target)) {
        handler()
      }
    }

    if (options.closeOnEsc) document.addEventListener("keydown", handleKeyPress)
    if (options.closeOnOutsideClick) {
      document.addEventListener("mousedown", handleClick)
      document.addEventListener("touchstart", handleClick)
    }

    return () => {
      if (options.closeOnEsc) document.removeEventListener("keydown", handleKeyPress)
      if (options.closeOnOutsideClick) {
        document.removeEventListener("mousedown", handleClick)
        document.removeEventListener("touchstart", handleClick)
      }
    }
  }, [handler, options.closeOnEsc, options.closeOnOutsideClick])

  return domNode
}